import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSocialWallet } from '../../common/hooks/useSocialWallet'
import { useSocialWalletState } from '../../common/socialWalletAtom'
import { CleanOutlineButton } from '../buttons/CleanOutlineButton'


export default function UserSignupScreen({
  children,
}: {
  children?: React.ReactNode
}) {
  const {
    inited,
    isLoggedIn,
    isLoading,
    userInfoRes,
    pubKey,
    balance,
    loginWithGoogle,
    loginWithGoogleRes,
    signAndSendTransactionFromWeb3Auth,
    sendTxRes,
  } = useSocialWallet()

  const { hasBeenLoggedInWithGoogle, setHasBeenLoggedInWithGoogle } =
    useSocialWalletState()


  const router = useRouter()

  useEffect(() => {
    router.prefetch('/app')
  }, [])

  useEffect(() => {
    if (inited && isLoggedIn) {
      router.push('/app')
    }
  }, [inited, isLoggedIn])

  const clickLoginWithGoogle = async () => {
    setHasBeenLoggedInWithGoogle(true)
    const [prefetchRes, isLoginSuccess] = await Promise.all([
      router.prefetch('/app'),
      loginWithGoogle(),
    ])
    
    if (isLoginSuccess) {
      console.log('login with google success')
      router.push('/app')
    }
  }

  return (
    <Box minHeight={'100vh'} bg='#38845B' width='100vw'>
      <Stack
        minHeight={'100vh'}
        maxWidth={'480px'}
        position={'relative'}
        backgroundImage='/maryJane2023/white-bg-texture.png'
        backgroundRepeat={'no-repeat'}
        backgroundSize={'contain'}
        backgroundPosition={'0 -220px'}
      >
        <Box paddingBottom='1rem' bg='transparent' paddingX='1rem'>
          <Flex mt='18px' justifyContent={'center'}>
            <Image
              height='32px'
              src='/images/payleaf-logo-white-with-text.png'
            ></Image>
          </Flex>
          <Flex mt='10px' justifyContent={'center'}>
            <Image
              borderRadius={'12px'}
              height='200px'
              src='/maryJane2023/hologram-ape-min.png'
            ></Image>
          </Flex>

          <Text
            color='white'
            fontWeight={700}
            fontSize='1.1rem'
            mt='1rem'
            textAlign={'center'}
          >
            PayLeaf allows anyone, anywhere to send and receive money and
            digital assets.
          </Text>
          <Stack mt='1.4rem' paddingX='1.6rem'>
            <Flex alignItems={'center'} justifyContent={'flex-start'}>
              <Flex
                borderRadius={'full'}
                justifyContent={'center'}
                alignItems={'center'}
                p={2}
                height='30px'
                width='30px'
                minW='30px'
                border='1px solid #fff'
              >
                <Text
                  textAlign='center'
                  fontWeight={700}
                  fontSize='1rem'
                  color='white'
                >
                  1
                </Text>
              </Flex>
              <Text ml={3} fontWeight={500} fontSize='.875rem' color='white'>
                Login with Google
              </Text>
            </Flex>
            <Flex alignItems={'center'} justifyContent={'flex-start'}>
              <Flex
                borderRadius={'full'}
                justifyContent={'center'}
                alignItems={'center'}
                p={2}
                height='30px'
                width='30px'
                minW='30px'
                border='1px solid #fff'
              >
                <Text
                  textAlign='center'
                  fontWeight={700}
                  fontSize='1rem'
                  color='white'
                >
                  2
                </Text>
              </Flex>

              <Text
                ml={3}
                textAlign='left'
                fontWeight={500}
                fontSize='.875rem'
                color='white'
              >
                Top up your account by credit card, bank account or crypto
              </Text>
            </Flex>
            <Flex alignItems={'center'} justifyContent={'flex-start'}>
              <Flex
                borderRadius={'full'}
                justifyContent={'center'}
                alignItems={'center'}
                p={2}
                height='30px'
                width='30px'
                minW='30px'
                border='1px solid #fff'
              >
                <Text
                  textAlign='center'
                  fontWeight={700}
                  fontSize='1rem'
                  color='white'
                >
                  3
                </Text>
              </Flex>

              <Text
                ml={3}
                textAlign='left'
                fontWeight={500}
                fontSize='.875rem'
                color='white'
              >
                Start sending digital assets to anyone, anywhere
              </Text>
            </Flex>
          </Stack>

          <Flex mt='1rem' justifyContent={'center'}>
            <CleanOutlineButton
              isLoading={loginWithGoogleRes.loading || isLoading}
              bg='white'
              onClick={clickLoginWithGoogle}
            >
              <Image
                height='1.6rem'
                mr='.2rem'
                borderRadius={'full'}
                src={'/images/app/g-logo.png'}
              />
              Login with Google
            </CleanOutlineButton>
          </Flex>
          <Text
            color='white'
            mt='1rem'
            fontWeight={500}
            fontSize='.675rem'
            textAlign={'center'}
          >
            No wallet needed to get started. By clicking "Login With Google" you <br></br>
            agree to our terms and conditions.
          </Text>
        </Box>
      </Stack>
    </Box>
  )
}
